import React, { useState } from 'react';
// import {operator} from '../components/affiliate';

function Todo({todo, index}) {
    return (
           
            <li class="card">
              <img src={todo.img} className="card-img-top" alt="..." />
              <div class="card-body">
                  <p className="card__price">{todo.ordpris}</p>
                <h3 class="card__title">{todo.prodnamn}</h3>
                <p className="card__brodtext">{todo.text}</p>
                <a href={todo.recUrl} className="card__link">Läs recension</a>
                <a href={todo.buttonUrl} class="btn btn-warning" target="_blank" rel="noopener noreferrer">Köp nu</a>
              </div>
            </li>  
    )
}

function App() {
    // const namn = {operator};
    // console.log(namn.operator[0]);
    const [todos] = useState([
        {
            img: '/oral-b-pro-2-2000.webp',
            pris: '599:-',
            ordpris: '599:-',
            prodnamn: 'PRO 2 2000 White',
            text: 'Sensi UltraThin Eltandborste',
            recUrl: '/pro2',
            buttonUrl: 'https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-pro-2-2000-white-sensi-ultrathin-eltandborste'
        },
        {
            img: '/oral-b-smart-4500.webp',
            pris: '999:-',
            ordpris: '999:-',
            prodnamn: 'Smart 4500 3D Pink',
            text: 'Den tar bort upp till 100 % mer plack.',
            recUrl: '/smart4500',
            buttonUrl: 'https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-oral-b-smart-4500-3d-pink-'
        },
        {
            img: '/oral-b-pro-2-2200s_1.webp',
            pris: '599:-',
            ordpris: '599:-',
            prodnamn: 'PRO 2 2200S Blue',
            text: 'Sensi UltraThin Eltandborste',
            recUrl: '/pro2',
            buttonUrl: 'https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-pro-2-2200s-blue-sensi-ultrathin-eltandborste'
        }
    ])

    return (
            <ul class="card-show">
                {todos.map((todo, index) => (
                <Todo key={index} index={index} todo={todo} /> 
                ))}
            </ul>
    )

}

export default App;